import { TablePageLayout, DataTableExRef } from '@kirz/mui-admin';
import AddIcon from '@mui/icons-material/Add';
import { Button } from '@mui/material';
import React, { useRef } from 'react';

import { WebFormsTable } from 'components/WebFormsTable';
import { HideStationSelector } from 'layouts/HideStationSelector';

export function WebForms() {
  const tableRef = useRef<DataTableExRef>(null);

  return (
    <HideStationSelector>
      <TablePageLayout
        title="Formulieren"
        // actionContent={
        //   <Button
        //     sx={{ ml: 5 }}
        //     variant="contained"
        //     startIcon={<AddIcon />}
        //     onClick={() => {
        //       tableRef.current?.openFormDialog();
        //     }}
        //   >
        //     Formulier toevoegen
        //   </Button>
        // }
      >
        <WebFormsTable
          id="web-forms-table"
          ref={tableRef}
          searchFilter={{
            inputProps: {
              placeholder: 'Zoeken op naam',
            },
            filter: (search) => ({
              _or: search.flatMap((str) => [
                { name: { _ilike: `%${str}%` } },
                { slug: { _ilike: `%${str}%` } },
              ]),
            }),
          }}
        />
      </TablePageLayout>
    </HideStationSelector>
  );
}
